import React, { useState, useEffect } from "react";
import { CheckOutlined, CloseOutlined, SearchOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import { Form, Input, Button, Row, Col, Card, message, Divider, Modal, Tooltip } from "antd";
import { useSelector } from "react-redux";
import PatronagerService from "../../../../../services/Election/Patronage/PatronagerService";
import VotersList from "../voters-list";
import { capitalizeFirstLetter } from "../../../../../helpers/StringFormatter";
import { isValidValue, setFormFieldValue } from "../../../../../helpers/FormHelper";



const NewAdd = ({ onBack, onSuccess }) => {
    const token = useSelector((state) => state.Member.token);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [voter, setVoter] = useState(null);
    const [searchModal, setSearchModal] = useState(false);
    const [modalResetNumber, setModalResetNumber] = useState({ searchModal: 0 });


    const longTitle = "Jeni duke shtuar një të referuar të ri";
    const shortTitle = "Shto të referuar";


    useEffect(() => {
        form.setFieldsValue({
            nid: voter ? voter.nid : "",
            name: voter ? voter.name : "",
            surname: voter ? voter.surname : "",
            father_name: voter ? voter.father_name : "",
            birthdate: voter ? voter.dob : ""
        });
    }, [form, voter]);


    const openSearchModal = () => {
        setSearchModal(true);
    };


    const closeSearchModal = () => {
        setSearchModal(false);
        setModalResetNumber({
            searchModal: modalResetNumber.searchModal + 1
        });
    };


    const updateVoter = (newVoter) => {
        setVoter(newVoter);
    };


    const formatRequestData = (data) => {
        const requestData = {
            voter_id: voter ? voter.id : null,
            comment: capitalizeFirstLetter(data?.comment),
        }

        if (isValidValue(data?.referrer)) {
            requestData.referues = capitalizeFirstLetter(data?.referrer);
        }

        if (isValidValue(data?.referrerPhone)) {
            requestData.referues_phone = setFormFieldValue(data?.referrerPhone);
        }

        return requestData;
    };


    const validateData = (data) => {
        if (!voter) {
            return false;
        }
        if (data.name === null || data.name === '') {
            return false;
        }
        return true;
    };


    const onSave = (e) => {
        setLoading(true);
        form
            .validateFields()
            .then((data) => {
                if (!validateData(data)) {
                    setLoading(false);
                    return;
                }
                const requestData = formatRequestData(data);
                PatronagerService.addReferredByPatronager(token, requestData)
                    .then((response) => {
                        message.success("Shtimi u krye me sukses!", 1)
                            .then(
                                onSuccess(),
                                setLoading(false),
                            );
                    })
                    .catch((err) => {
                        let errorMessage = "Një gabim ndodhi gjatë komunikimit me serverin!";
                        if (err.response) {
                            errorMessage = err.response.data.Error ? err.response.data.Error : "Një gabim ndodhi gjatë modifikimit!";
                        }
                        message.error(errorMessage, 2).then(() => {
                            setLoading(false);
                        });
                    });
            })
            .catch((err) => {
                setLoading(false);
            });
    };


    return (
        <Row gutter={24}>
            <Col span={24}>
                <Row gutter={24}>
                    <Col span={24}>
                        <Row gutter={24}>
                            <Col xl={24} lg={0} md={0} sm={0} xs={0}>
                                <Card style={{ borderRadius: "0" }}>
                                    <Row gutter={24} align="middle">
                                        <Col xl={4} lg={4} sm={4} md={4} xs={4}></Col>
                                        <Col xl={16} lg={16} sm={16} md={16} xs={16} className="text-center">
                                            <h3 style={{ padding: "0", margin: "0" }}>
                                                {longTitle}
                                            </h3>
                                        </Col>
                                        <Col xl={4} lg={4} sm={4} md={4} xs={4} className="text-right">
                                            <Button
                                                block
                                                size="large"
                                                type="secondary"
                                                onClick={onBack}
                                                icon={<ArrowLeftOutlined />}
                                            >
                                                Kthehu
                                            </Button>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                            <Col xl={0} lg={24} md={24} sm={24} xs={24}>
                                <Card style={{ borderRadius: "0" }} className="text-center">
                                    <Row gutter={24} align="middle">
                                        <Col xl={4} lg={4} sm={4} md={4} xs={4}></Col>
                                        <Col xl={16} lg={16} sm={16} md={16} xs={16} className="text-center">
                                            <h3 style={{ padding: "0", margin: "0" }}>
                                                {shortTitle}
                                            </h3>
                                        </Col>
                                        <Col xl={4} lg={4} sm={4} md={4} xs={4} className="text-right">
                                            <Tooltip title="Kthehu">
                                                <Button
                                                    size="large"
                                                    type="secondary"
                                                    onClick={onBack}
                                                    icon={<ArrowLeftOutlined />}
                                                />
                                            </Tooltip>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row gutter={24} className="mt-2">
                    <Col span={24}>
                        <Card bodyStyle={{ padding: "30px" }}>
                            <Form
                                labelCol={{ span: 7 }}
                                layout="horizontal"
                                labelAlign="left"
                                form={form}
                            >
                                <Row gutter={24}>
                                    <Col xl={5} lg={5} md={24} sm={24} xs={24}></Col>
                                    <Col xl={11} lg={11} md={24} sm={24} xs={24}>
                                        <Form.Item label="Emri:" name="name">
                                            <Input type="text" disabled={true} className="w-100" />
                                        </Form.Item>
                                        <Form.Item label="Mbiemri:" name="surname">
                                            <Input type="text" disabled={true} className="w-100" />
                                        </Form.Item>
                                        <Form.Item label="Atësia:" name="father_name">
                                            <Input type="text" disabled={true} className="w-100" />
                                        </Form.Item>
                                        <Form.Item label="Datëlindja:" name="birthdate">
                                            <Input type="text" disabled={true} className="w-100" />
                                        </Form.Item>
                                        <Form.Item label="Komenti:" name="comment">
                                            <Input.TextArea type="text" rows={4} className="w-100" />
                                        </Form.Item>
                                    </Col>
                                    <Col xl={8} lg={8} md={24} sm={24} xs={24}>
                                        <Button
                                            type="primary"
                                            className="ml-4"
                                            onClick={openSearchModal}
                                            icon={<SearchOutlined />}
                                        >
                                            Kërkim i avancuar
                                        </Button>
                                    </Col>
                                </Row>
                                <Row gutter={24}>
                                    <Col span={24}>
                                        <Divider className="w-100 mt-1" />
                                    </Col>
                                </Row>
                                <Row gutter={24}>
                                    <Col xl={5} lg={5} md={24} sm={24} xs={24} />
                                    <Col xl={11} lg={11} md={24} sm={24} xs={24}>
                                        <Form.Item
                                            label="Referuesi:"
                                            name="referrer"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: "Ju lutem, shënoni emrin e referuesit!",
                                                },
                                            ]}
                                        >
                                            <Input type="text" className="w-100" />
                                        </Form.Item>

                                        <Form.Item
                                            label="Telefoni i referuesit:"
                                            name="referrerPhone"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: "Ju lutemi, shënoni një numër telefoni të vlefshëm.",
                                                },
                                            ]}
                                        >
                                            <Input type="text" className="w-100" />
                                        </Form.Item>

                                    </Col>
                                </Row>
                                <Row gutter={24}>
                                    <Col span={24}>
                                        <Divider className="w-100" />
                                    </Col>
                                </Row>
                                <Row gutter={24} className='mt-3'>
                                    <Col xl={24} lg={24} md={24} sm={24} xs={24} className='text-center'>
                                        <Button
                                            type="primary"
                                            className="mr-4"
                                            style={{ width: "180px" }}
                                            onClick={() => onSave()}
                                            loading={loading}
                                            disabled={!voter ? true : false}
                                            icon={<CheckOutlined />}
                                            size="large"
                                        >
                                            Ruaj
                                        </Button>
                                        <Button
                                            danger
                                            onClick={onBack}
                                            style={{ width: "180px" }}
                                            icon={<CloseOutlined />}
                                            size="large"
                                        >
                                            Mbyll
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col span={24}>
                        <Modal
                            title={"Lista e votuesve!"}
                            centered
                            style={{ minWidth: "60%" }}
                            visible={searchModal}
                            onCancel={closeSearchModal}
                            destroyOnClose={true}
                            footer={false}
                        >
                            <VotersList
                                voter={voter}
                                updateVoter={updateVoter}
                                onClose={closeSearchModal}
                            />
                        </Modal>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};


export default NewAdd;